import AsyncPage from 'pages/AsyncPage'

import universal from 'react-universal-component'
const component = universal(props => import('./LoginWithEmailPage'))

export default new AsyncPage({
  isChromeless: true,
  pageComponent: component
})
